var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.spCheckDataList),function(item,index){return _c('div',{key:index,staticClass:"alert-container"},[_c('div',[_c('i',{staticClass:"QS-icon-warning"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item))])]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":_setup.goToConf}},[_vm._v("去配置")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }